import gql from 'graphql-tag';

export default ({ id, status }) => {
  const updateDiscountOfferStatus = `updateDiscountOfferStatus(input: { id: "${id}", status: ${status}})`;
  return gql`
  mutation {
    ${updateDiscountOfferStatus} {
      id
      status
    }
  }
`;
};
